export default __webpack_public_path__ + "static/media/olivia_lesslar.64358d69.jpg";